import { useStaticQuery, graphql } from "gatsby"
import { useIntl } from "react-intl"

/**
 * @returns
 *  categories: array of all Cosmic milestone objects for the current locale
 *  getCategoryLabel: given a milestone slug, get it's locale-specific title
 */
const useMilestoneCategories = () => {
  const { locale } = useIntl()
  const { allCosmicjsMilestones } = useStaticQuery(graphql`
    query {
      allCosmicjsMilestones {
        nodes {
          slug
          title
          locale
        }
      }
    }
  `)

  const categories = (allCosmicjsMilestones.nodes || []).filter(n => n.locale === locale)

  const getCategoryLabel = (slug) => categories.find(c => c.slug === slug)?.title || slug

  return { categories, getCategoryLabel }
}

export default useMilestoneCategories
